<template>
    <div class="card-container"
    @click="openDrawer(collaborator)">
      <div style="display: flex; align-items: center;">
        <div class="card-img">
          <img style="padding: 10px;"
            :src="require('@/assets/imgs/svgs/logo-default.svg')"
            alt="logo">
          <div :class="collaborator.active ? 'active-indicator' : 'inactive-indicator' "></div>
        </div>
        <div class="card-info">
          <span class="title-card">
            {{collaborator.name}}
          </span>
          <span> {{collaborator.email}} </span>
          <span> {{ collaborator.role.description }} </span>
        </div>
      </div>
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
        </template>
        <v-list>
          <v-list-item  title="Editar" link
          @click="editColaborator(collaborator)"/>
          <v-list-item  title="Cambiar contraseña" link
          @click="editPass(collaborator)" />
          <v-list-item  :title="collaborator.active ? 'Bloquear' : 'Reactivar' "
          link @click="openDialogActive()" />
          <v-list-item  title="Eliminar" link
          @click="openDialogDelete()"/>
        </v-list>
      </v-menu>
    </div>

    <add-edit-collaborators ref="addEditModal" @refreshList="refresh"/>

    <change-pass ref="changePass" @refreshList="refresh"/>

    <collaborators-drawer ref="drawer" @openEdit="editColaborator"/>

    <diaog-two-options
      ref="activeDialog"
      @okBtn="activeColaborator(collaborator)"
      :title="collaborator.active ?  'Bloquear colaborador': 'Reactivar colaborador' "
      :txtBtn="collaborator.active ? 'Sí, bloquear' : 'Sí, reactivar' "
      :txtBold="collaborator.name"
      txtOne=""
      :txtTwo="collaborator.active
      ? ' no podrá ingresar a la aplicación móvil. ¿Deseas continuar?'
      : ' podrá usar nuevamente la aplicación móvil. ¿Deseas continuar?' "/>

    <diaog-two-options
      ref="deleteDialog"
      @okBtn="deleteColaborator(collaborator)"
      title="Eliminar colaborador"
      txtBtn="Sí, Eliminar"
      :txtBold="collaborator.name"
      txtOne="¿Deseas eliminar a "
      txtTwo="? No podrás deshacer la acción."/>
  </template>
<script>
import AddEditCollaborators from '@/components/forms/AddEditCollaborators.vue'
import DiaogTwoOptions from '@/components/dialogs/DiaogTwoOptions.vue'
import colaboratorsApi from '@/api/collaboratorsApi'
import ChangePass from '../forms/ChangePass.vue'
import CollaboratorsDrawer from '../drawers/CollaboratorsDrawer.vue'

export default {
  name: 'CommerciaVueCollaboratorCard',
  emits: ['refreshList'],
  components: {
    AddEditCollaborators,
    DiaogTwoOptions,
    ChangePass,
    CollaboratorsDrawer
  },
  props: {
    collaborator: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      business: this.$store.getters.business
    }
  },
  methods: {
    editColaborator (colaborator) {
      this.$refs.addEditModal.edit(colaborator)
    },
    editPass (colaborator) {
      this.$refs.changePass.edit(colaborator)
    },
    async activeColaborator (collaborator) {
      if (await colaboratorsApi.changeActive(collaborator)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    async deleteColaborator (collaborator) {
      if (await colaboratorsApi.delete(collaborator)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    openDrawer (colaborator) {
      this.$refs.drawer.show(colaborator)
    },
    openDialogActive () {
      this.$refs.activeDialog.open()
    },
    openDialogDelete () {
      this.$refs.deleteDialog.open()
    },
    openChangePass () {
      this.$refs.changePass.open()
    },
    refresh () {
      this.$emit('refreshList')
    }

  }
}
</script>
<style scoped>
  @import '@/assets/styles/cards.css';
</style>
